// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import Header from './Header'
import ShareButton from './ShareButton'

class ShareHeader extends React.Component {
  constructor () {
    super();
  }

  render () {
    // TODO: Find a better way to align the share buttons with the other headers
    // Probably just hide the drop down option
    return (
      <div style={{width:"100%", display: 'flex'}}>
        <div style={{flex: 1}}>
          <Header>{this.props.children}</Header>
        </div>
        <div style={{marginRight: '42.5px'}}>
          <ShareButton
            hasEditPermission={this.props.hasEditPermission}
          />
        </div>
      </div>
    );
  }
}

export default ShareHeader;
